/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { SelectFieldItemEdit } from "./edit-item";

const SelectFieldEdit = () => {
    return (
        <FieldListEditWrapper>
            <SelectFieldItemEdit />
        </FieldListEditWrapper>
    );
};
SelectFieldEdit.displayName = "SelectFieldEdit";
export { SelectFieldEdit };
